import React, { useEffect, useMemo } from "react";
import { Button, Card, Col, Divider, Rate, Row, Spin } from "antd";
import TrackCard from "../../components/track-card";
import {
  DollarOutlined,
  MoneyCollectOutlined,
  StarOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import TrackImage from "../../assets/track-overview.png";
import TrainerImage from "../../assets/trainer.png";
import ProfessionalCertificateImage from "../../assets/professional-certificate.png";

import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { getTrack } from "../../store/apis/tracks";
import Loader from "../../components/loader";
import { getCourseById } from "../../store/apis/courses";
import TrackCourses from "../../components/trackCourses";
import { useNavigate } from "react-router-dom";

function TrackCoursesPage() {
  const trackState = useSelector((state) => state.tracks.track);

  const renderTrackHead = () => {
    return (
      <div className="track-head">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="head-description">
              <h2> {trackState?.title} </h2>
              <p>{trackState?.description}</p>
              {/* <span> المدرب : {trackState?.trainer} </span> */}
              <span>م. محمد الطويل</span>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="head-image">
              <img
                src={
                  trackState?.thumnil != ""
                    ? `https://golancer.tech/admin/file/${trackState?.thumnil}`
                    : TrackImage
                }
                crossorigin="anonymous"
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  };
  return (
    <div className="track-courses-page-container">
      {renderTrackHead()}
      <TrackCourses />
    </div>
  );
}

export default TrackCoursesPage;
